import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';

const DynamicSiteMenuPositioner = () => import(/* webpackChunkName: "dynamic-site-menu-positioner" */ './dynamic-site-menu-positioner.vue');
const GAMTopLeaderboardLeaveBehind = () => import(/* webpackChunkName: "top-leaderboard-leave-behind" */ './top-leaderboard-leave-behind.vue');
const CompanySearch = () => import(/* webpackChunkName: "global-company-search" */ './company-search.vue');
const SectionSearch = () => import(/* webpackChunkName: "global-section-search" */ './section-search.vue');

export default (Browser) => {
  const { EventBus } = Browser;
  MonoRail(Browser);
  Leaders(Browser);
  Browser.register('DynamicSiteMenuPositioner', DynamicSiteMenuPositioner);
  Browser.register('GAMTopLeaderboardLeaveBehind', GAMTopLeaderboardLeaveBehind);
  Browser.register('GlobalCompanySearch', CompanySearch, {
    provide: { EventBus },
  });
  Browser.register('GlobalSectionSearch', SectionSearch, {
    provide: { EventBus },
  });
};
